import { render, staticRenderFns } from "./dataViewing.vue?vue&type=template&id=14b94106&scoped=true"
import script from "./dataViewing.vue?vue&type=script&lang=js"
export * from "./dataViewing.vue?vue&type=script&lang=js"
import style0 from "./dataViewing.vue?vue&type=style&index=0&id=14b94106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b94106",
  null
  
)

export default component.exports